import BaseApiManager from './BaseApiManager'
import axios from '../../../../config/axios'

/**
 * Therapist API Manager.
 */
export default class TherapistApiManager extends BaseApiManager {

  /**
   * Create entity.
   *
   * @param {String} username
   * @param {String} displayName
   * @param {Array<integer>} curatorIds
   * @param {String} password
   * @param {String} passwordConfirmation
   *
   * @returns {Promise<any>}
   */
  async create ({username, displayName, curatorIds, password, passwordConfirmation}) {
    return await axios.post(`${this.url}`, {
      username,
      displayName,
      curatorIds,
      password,
      passwordConfirmation
    })
  }

  /**
   * Add clients to therapist.
   *
   * @param {Number} therapistId
   * @param {Array} clientIds
   * @returns {Promise<any>}
   */
  async addClients ({therapistId, clientIds}) {
    return await axios.post(`${this.url}/${therapistId}/clients`, {
      clientIds,
    })
  }

  /**
   * Update entity.
   *
   * @param {Number} id
   * @param {String} username
   * @param {String} displayName
   * @param {Array<integer>} curatorIds
   * @param {String} password
   * @param {String} passwordConfirmation
   *
   * @returns {Promise<any>}
   */
  async update ({id, username, displayName, curatorIds, password, passwordConfirmation}) {
    return await axios.put(`${this.url}/${id}`, {
      username,
      displayName,
      curatorIds,
      password,
      passwordConfirmation
    })
  }

  /**
   * Paginate all entities.
   *
   * @param {Number} therapistId
   * @param {Number} perPage
   * @param {Number} page
   * @param {String} sort
   * @param {String} search
   * @param {Boolean} isOwn
   * @returns {Promise<any>}
   */
  async paginateAllClientsByTherapistId (
    {
      therapistId, perPage = 5, page = 1, sort, search, isOwn
    },
  ) {
    return await axios.get(
      `${this.url}/${therapistId}/clients/${perPage}/${page}`, {
        params: {
          sort,
          search,
          isOwn,
        },
      })
  }

  /**
   * Delete Client form Therapist.
   *
   * @param {Number} therapistId
   * @param {Number} clientId
   * @returns {Promise<any>}
   */
  async deleteClient (therapistId, clientId) {
    return await axios.delete(`${this.url}/${therapistId}/clients/${clientId}`)
  }

  /**
   * Check access to client.
   *
   * @param {Number} therapistId
   * @returns {Promise<AxiosPromise<any>>}
   */
  async hasAccess(therapistId) {
    return this.axios.get(`${this.url}/${therapistId}/access`)
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/api/managers/TherapistApiManager.ts